import RelatorioStrategyBase from "./RelatorioStrategyBase";
import moment from "moment";
import FormContasReceber from "../filtros/FormContasReceber";

export default class ContasReceberStrategy extends RelatorioStrategyBase {
  processar(dadosBrutos) {
    const grupos = [];
    let totaisGerais = { bruto: 0, brutoUsd: 0, retencao: 0, retencaoUsd: 0, descontos: 0, descontosUsd: 0, pago: 0, pagoUsd: 0, saldo: 0, saldoUsd: 0 };

    if (!Array.isArray(dadosBrutos)) {
      return { titulo: "CONTAS A RECEBER", grupos, totaisGerais };
    }

    const por = this.opcoes.por || "porCliente";
    const isEnglish = parseInt(this.opcoes.moeda) !== 5 || this.opcoes.mostrarAmbasMoedas;
    const agrupado = {};

    dadosBrutos.forEach((item) => {
      if (item.contas && Array.isArray(item.contas)) {
        item.contas.forEach((conta) => {
          const adapter = {
            vencimento: conta.vencimento || null,
            os: conta.os || "N/A",
            documento: conta.documento || "",
            navio: conta.navio || conta.navio_nome || conta.manual_navio_nome || "N/A",
            bruto: parseFloat(conta.bruto || 0),
            retencao: parseFloat(conta.retencao || 0),
            descontos: parseFloat(conta.descontos || 0),
            pago: parseFloat(conta.pago || 0),
            saldo: parseFloat(conta.saldo || 0),
            moeda: conta.moeda || 5,
            roe: parseFloat(conta.roe || conta.os_roe || 5),
            sailed: conta.sailed || null
          };
          const linha = this.criarLinhaTabela(adapter);
          
          if (linha.saldo > 0.01) {
            let chaveGrupo = isEnglish ? "GROUP" : "GRUPO";
            if (por === "porCliente") {
              chaveGrupo = `${isEnglish ? 'CLIENT' : 'CLIENTE'}: ${(item.pessoa?.nome || item.pessoa_nome || "N/A").toUpperCase()}`;
            } else if (por === "porVencimento") {
              chaveGrupo = `${isEnglish ? 'DUE DATE' : 'VENCIMENTO'}: ${moment(item.lancamento || conta.vencimento).format("DD/MM/YYYY")}`;
            } else if (por === "porLancamento") {
              chaveGrupo = `${isEnglish ? 'LAUNCH' : 'LANÇAMENTO'}: ${moment(item.lancamento || conta.Lancto).format("DD/MM/YYYY")}`;
            } else if (por === "porData") {
              chaveGrupo = `${isEnglish ? 'DATE' : 'DATA'}: ${moment(item.lancamento || conta.dataPagamento || conta.vencimento).format("DD/MM/YYYY")}`;
            } else if (por === "porOS") {
              chaveGrupo = `OS: ${conta.os || conta.os_codigo || "N/A"}`;
            } else if (por === "porTaxa") {
              chaveGrupo = `${isEnglish ? 'FEE' : 'TAXA'}: ${conta.nome_taxa || item.nome_taxa || "N/A"}`;
            } else if (por === "porGrupoTaxa") {
              chaveGrupo = `${isEnglish ? 'FEE GROUP' : 'GRUPO DE TAXA'}: ${conta.grupo_taxa || item.grupo_taxa || "N/A"}`;
            }

            if (!agrupado[chaveGrupo]) {
              agrupado[chaveGrupo] = {
                nome: chaveGrupo,
                rows: [],
                totais: { bruto: 0, brutoUsd: 0, retencao: 0, retencaoUsd: 0, descontos: 0, descontosUsd: 0, pago: 0, pagoUsd: 0, saldo: 0, saldoUsd: 0 },
                hasDiscount: false
              };
            }
            
            agrupado[chaveGrupo].rows.push(linha);
            agrupado[chaveGrupo].totais.bruto += linha.bruto; agrupado[chaveGrupo].totais.brutoUsd += (linha.brutoUsd || 0);
            agrupado[chaveGrupo].totais.retencao += linha.retencao; agrupado[chaveGrupo].totais.retencaoUsd += (linha.retencaoUsd || 0);
            agrupado[chaveGrupo].totais.descontos += linha.descontos; agrupado[chaveGrupo].totais.descontosUsd += (linha.descontosUsd || 0);
            agrupado[chaveGrupo].totais.pago += linha.pago; agrupado[chaveGrupo].totais.pagoUsd += (linha.pagoUsd || 0);
            agrupado[chaveGrupo].totais.saldo += linha.saldo; agrupado[chaveGrupo].totais.saldoUsd += (linha.saldoUsd || 0);
            if (linha.descontos > 0) agrupado[chaveGrupo].hasDiscount = true;

            totaisGerais.bruto += linha.bruto; totaisGerais.brutoUsd += (linha.brutoUsd || 0);
            totaisGerais.retencao += linha.retencao; totaisGerais.retencaoUsd += (linha.retencaoUsd || 0);
            totaisGerais.descontos += linha.descontos; totaisGerais.descontosUsd += (linha.descontosUsd || 0);
            totaisGerais.pago += linha.pago; totaisGerais.pagoUsd += (linha.pagoUsd || 0);
            totaisGerais.saldo += linha.saldo; totaisGerais.saldoUsd += (linha.saldoUsd || 0);
          }
        });
      }
    });

    Object.values(agrupado).forEach((grupo) => {
      if (grupo.rows.length > 0) {
        grupo.rows.sort((a, b) => moment(a.sailed).diff(moment(b.sailed)));
        grupos.push(grupo);
      }
    });

    return {
      titulo: "CONTAS A RECEBER",
      grupos,
      totaisGerais,
    };
  }

  getFormComponent() {
    return FormContasReceber;
  }
}